import { createFileRoute, Outlet } from "@tanstack/react-router";
import Header from "@/components/Header";

export function ErrorLayout() {
	return (
		<>
			<Header />
			<Outlet />
		</>
	);
}

/* istanbul ignore start -- TanStack Router file route registration */
export const Route = createFileRoute("/_error")({
	component: ErrorLayout,
});
/* istanbul ignore end */
